export const CREATE_MODULE_HELP_LINK = 'https://help.hotmart.com/article/360000645592';
